import { useSelector } from 'react-redux';

import { FeatureFlagsAvailable } from '@components/featureFlags';
import { selectFeatureFlags } from '@reducers/user';
import { FINISH_JOB_FEATURE_FLAG } from '@v2/components/FinishJobModal/constants';

const useIsFinishJobEnabled = () => {
  const featureFlags = useSelector(selectFeatureFlags) ?? {};

  return FeatureFlagsAvailable(FINISH_JOB_FEATURE_FLAG, featureFlags);
};

export default useIsFinishJobEnabled;
